<div class="filter-did">
  <div
    class="filter-did__dropdown vox-dropdown-input"
    ngbDropdown>
    <button
      type="button"
      class="filter-did__dropdown-toggle"
      [title]="selectedDid.label + ' ' + selectedDid.number"
      ngbDropdownToggle
      *ngIf="selectedDid">
      <span class="filter-did__dropdown-toggle-text"> {{ selectedDid.label }} ({{ selectedDid.number }}) </span>
    </button>
    <button
      type="button"
      class="filter-did__dropdown-toggle"
      ngbDropdownToggle
      *ngIf="!selectedDid">
      {{ "events.company-call-history.filters.options.all-dids" | Translate }}
    </button>
    <ul
      class="filter-did__dropdown-menu"
      ngbDropdownMenu>
      <li
        class="filter-did__dropdown-item"
        ngbDropdownItem
        (click)="selectDid(null)">
        {{ "events.company-call-history.filters.options.all-dids" | Translate }}
      </li>
      <li
        class="filter-did__dropdown-item"
        ngbDropdownItem
        (click)="selectDid(did)"
        *ngFor="let did of dids">
        {{ did.label }} ({{ did.number }})
      </li>
    </ul>
  </div>
</div>
